
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { required } from "@vuelidate/validators";

import enUK from "@/locales/project/en-UK.json";

import { COPY_PROJECT, COPY_PROJECT_PHASES } from "@/graphql/project/mutations";

import MutateEntity from "@/components/CRUXEntity/MutateEntity.vue";
import { TransferProjectResult } from "@/helpers/typesDefinition";

type MessageSchema = typeof enUK;

export default defineComponent({
  name: "TransferProjectModal",
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  emits: ["close"],
  components: {
    MutateEntity,
  },
  setup(props, { emit }) {
    const { t } = useI18n<[MessageSchema], "en-UK">({
      useScope: "global",
      inheritLocale: true,
      messages: {
        "en-UK": enUK,
      },
    });

    const validationRules = computed(() => ({
      id: { required },
      name: { required },
    }));

    const chainedMutations = [
      {
        mutation: COPY_PROJECT_PHASES,
        mutationName: "transferProjectPhases",
        getVariables: (
          prev: TransferProjectResult,
        ): Record<string, unknown> => ({
          oldProjectId: prev.data.transferProject.data.oldProject.id,
          newProjectId: prev.data.transferProject.data.newProject.id,
          slugPrefix: prev.data.transferProject.data.newProject.client.prefix,
        }),
        messages: {
          error: t("errors.copy.phases"),
          success: t("success.copy.phases"),
        },
      },
    ];

    const messages = {
      formButtonLabel: t("buttons.copy"),
      error: t("errors.copy.project"),
      success: t("success.copy.project"),
    };

    const closeModal = () => emit("close");

    return {
      enUK,
      COPY_PROJECT,
      validationRules,
      chainedMutations,
      messages,
      closeModal,
    };
  },
});
